import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NAV, ENASUSPRO_URL } from "@/data/content";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-40"
      data-testid="site-nav"
    >
      <div
        className={`transition-[background-color,border-color,backdrop-filter] duration-300 ${
          scrolled ? "bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="ec-container flex h-[72px] items-center justify-between">
          <a href="#top" className="flex items-center gap-2" data-testid="nav-logo">
            <span className="grid h-8 w-8 place-items-center rounded-md bg-[#D4F870] font-display text-lg font-semibold text-[#0A0A0A]">
              e
            </span>
            <span className="font-display text-lg tracking-tight text-[#F3F4F6]">
              enasus<span className="text-[#D4F870]">carbon</span>
            </span>
          </a>

          <nav className="hidden items-center gap-8 md:flex">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="text-sm text-[#9CA3AF] transition-colors hover:text-[#F3F4F6]"
                data-testid={`nav-link-${n.href.replace(/[#/]/g, "")}`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="/login"
              className="hidden text-sm text-[#9CA3AF] transition-colors hover:text-[#F3F4F6] md:block"
              data-testid="nav-login"
            >
              Giriş
            </a>
            <a
              href="/welcome"
              className="rounded-full bg-[#D4F870] px-5 py-2 text-sm font-medium text-[#0A0A0A] transition-colors hover:bg-[#BEF264]"
              data-testid="nav-cta"
            >
              Ücretsiz Başla
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              className="grid h-9 w-9 place-items-center rounded-full border border-white/10 text-[#F3F4F6] md:hidden"
              data-testid="nav-mobile-toggle"
              aria-label="Menü"
            >
              <span className="text-lg">≡</span>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-white/10 bg-[#0A0A0A]/95 px-6 py-4 md:hidden" data-testid="nav-mobile-menu">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="block py-2 text-sm text-[#9CA3AF]"
              >
                {n.label}
              </a>
            ))}
            <a href={ENASUSPRO_URL} className="block py-2 text-sm text-[#D4F870]">
              Enasuspro'ya geç →
            </a>
          </div>
        )}
      </div>
    </motion.header>
  );
};
